import React from 'react';
import AccountingMasterRegister from './AccountingMasterRegister';

/** 기준정보 — 회계구분등록 */
const AcctClassRegister = () => <AccountingMasterRegister axis="class" />;

export default AcctClassRegister;

